import { serviceIdState } from '@/states/serviceInfoState';
import { useRecoilValue } from 'recoil';

/**
 * APIパスにserviceIdのパスパラメータを埋め込む
 * @returns 変換実行関数
 */
const useInsertServiceIdInApiUrl = () => {
  const serviceId = useRecoilValue(serviceIdState);

  /**
   * APIパスにserviceIdのパスパラメータを埋め込む
   * @param apiUrl APIのURL
   * @returns APIパスにserviceIdのパスパラメータを埋め込んだAPIのURL
   */
  const insertServiceIdInApiUrl = (apiUrl: string) => {
    // API定義のプレースホルダーを現在選択中サービスIDへ置き換える。
    const apiUrlWithServiceId = apiUrl.replace(':service_id', serviceId);

    return apiUrlWithServiceId;
  };

  return { insertServiceIdInApiUrl };
};

export default useInsertServiceIdInApiUrl;
